import Link from 'next/link';
import cx from 'classnames';
import { LinkGroups } from '../../constants';
import styles from '../../styles/footer.scss';

const FooterLinks = () => (
  <div className={cx(styles['link-container'], 'mt30 desktop-only')}>
    {LinkGroups.map(group => {
      return (
        <div
          className={cx(styles['link-group'], 'pb20')}
          key={group.groupLabel}
        >
          <div className="font--bold pb10 text--xmd">{group.groupLabel}</div>
          {group.links.map(link => (
            <div key={link.label}>
              <Link href={link.link}>
                <a target="_blank" className="text--md">
                  {link.label}
                </a>
              </Link>
            </div>
          ))}
        </div>
      );
    })}
  </div>
);

export default FooterLinks;



// WEBPACK FOOTER //
// ./components/footer/footerLinks.tsx